import Modal from './Modal';

export default Modal;



// WEBPACK FOOTER //
// ./src/components/shared/Modal/index.jsx